import fetchSwimLaneList from "../../fetch/graphql/requests/swimlaneList";
import { receive_sectional_content } from "../../reducers/SectionalContent/reducer";
import { set_loading_complete } from "../Loader/dispatchers";
import { start_loading } from "../../reducers/Loader/reducer";
import { getSwimLaneList } from "./utils";

const swimlaneList = (path) => (dispatch) => {
    let swimlaneList = getSwimLaneList(path).filter(
        (it) => it.type !== "localSubject"
    );

    if (swimlaneList.length === 0) {
        return Promise.resolve();
    }

    dispatch(start_loading());

    return fetchSwimLaneList(swimlaneList)
        .then((list) => {
            return list
                .map((it) => {
                    return receive_sectional_content({
                        sectionList: it.response,
                        section: it.section,
                        timestamp: Date.now(),
                    });
                })
                .map((it) => dispatch(it));
        })
        .finally((args) => {
            dispatch(set_loading_complete());
            return args;
        });
};

export default swimlaneList;
